import { Addresses } from '@/domain/addresses';
import { getChainConstant } from '@/domain/chain';
import useChainId from '@/hooks/useChainId';
import VeFloorStakingAbi from '@/infrastructure/abis/VeFloorStakingAbi';
import { useWaitForTransactionReceipt, useWriteContract } from 'wagmi';

const useUnstake = () => {
  const chainId = useChainId();

  const {
    writeContract: withdrawWrite,
    data: withdrawHash,
    error: withdrawError,
    isPending: isWithdrawPending,
  } = useWriteContract();

  const withdraw = () =>
    withdrawWrite({
      address: getChainConstant(Addresses, chainId, 'VeFloorStaking'),
      abi: VeFloorStakingAbi,
      functionName: 'withdraw',
    });

  const {
    data,
    isLoading: isConfirming,
    isSuccess: isConfirmed,
  } = useWaitForTransactionReceipt({
    hash: withdrawHash,
  });

  return {
    // if no penalty, can withdraw directly
    unstake: withdraw,
    receipt: data,
    isPending: isWithdrawPending,
    isConfirming,
    isConfirmed,
    error: withdrawError,
  };
};

export default useUnstake;
